import { NEXTJS_RSC_LOGGED_OUT_BRAND_PAGE_231106 } from "@faire/web-api/indigofair/settings/NEXTJS_RSC_LOGGED_OUT_BRAND_PAGE_231106";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

import { assignSetting } from "@faire/retailer/settings/__internal__/getSetting";

export function assignSettingRSCLoggedOutBrandPage() {
  if (getGlobalProperty("isNextJS", false)) {
    assignSetting(NEXTJS_RSC_LOGGED_OUT_BRAND_PAGE_231106);
  }
}
